import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../foundations/typography';
import { ActionBottomSheetVariantType, InputVariantType, LoaderVariantType, PopoverVariantType, TextVariantType, } from '../variants';
const getBoxShadow = (FOUNDATIONS) => {
    // SHADOW_40
    return `0rem ${FOUNDATIONS.spacing_75} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spread_negative_50} ${FOUNDATIONS.color_effect_shadow_drop_100}`;
};
export const commonStyles = (FOUNDATIONS, FONT) => ({
    inputVariant: InputVariantType.INPUT_DROPDOWN,
    allowSearch: true,
    cursor_pointer: 'pointer',
    popoverVariant: {
        [DeviceBreakpointsType.DESKTOP]: PopoverVariantType.INPUT_SEARCH,
        [DeviceBreakpointsType.TABLET]: PopoverVariantType.INPUT_SEARCH,
        [DeviceBreakpointsType.MOBILE]: PopoverVariantType.INPUT_SEARCH,
    },
    useActionBottomSheet: {
        [DeviceBreakpointsType.DESKTOP]: false,
        [DeviceBreakpointsType.TABLET]: true,
        [DeviceBreakpointsType.MOBILE]: true,
    },
    actionBottomSheetVariant: ActionBottomSheetVariantType.INPUT_DROPDOWN,
    searchListContainer: {
        background_color: FOUNDATIONS.color_exception_neutral_bg_850,
        margin_top: FOUNDATIONS.spacing_100,
        [DeviceBreakpointsType.DESKTOP]: {
            box_shadow: getBoxShadow(FOUNDATIONS),
            border_radius: FOUNDATIONS.radius_comp_containers_contextmenu_radiussize,
        },
    },
    loaderExpandedContainer: {
        height: 'auto',
        padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_300}`,
    },
    loaderContractedContainer: {
        height: '100%',
        padding: FOUNDATIONS.spacing_300,
    },
    loader: {
        variant: LoaderVariantType.SECONDARY,
    },
    noResultsTextContainer: {
        padding: `${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_200}`,
    },
    noResultsText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        color: FOUNDATIONS.color_neutral_font_50,
        font_weight: FONT_WEIGHT.font_regular,
    },
    loadingText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_neutral_font_100,
        font_weight: FONT_WEIGHT.font_regular,
    },
});
export const inputPhoneCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT),
    inputIcon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: 'initial',
    },
    inputVariant: InputVariantType.INPUT_DROPDOWN,
    inputDropdownContainer: {
        position: 'inherit',
    },
});
//# sourceMappingURL=commonStyles.js.map